import http from '@core/fetch'

export default {
  postCertify: body =>
    http.post('/p/wedding/Admin/APIMerchant/certify', { body }),

  aliFaceCertify: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/aliFaceCertify', {
      body,
      onError: false
    }),

  aliFaceCertifyStatus: body =>
    http('/p/wedding/index.php/Admin/APIMerchant/aliFaceCertifyStatus', {
      body
    }),

  getCertify: body => http('/p/wedding/Admin/APIMerchant/certify', { body }),

  initAuth: body =>
    http.post('/p/wedding/index.php/Admin/APIZmCertify/initAuth', { body }),

  checkAuth: body =>
    http.post('/p/wedding/index.php/Admin/APIZmCertify/checkAuth', { body })
}
